export default "__VITE_ASSET__KBpYo$LM__"